import { render } from "./TDMModalImport.vue?vue&type=template&id=2a5223d7"
import script from "./TDMModalImport.vue?vue&type=script&lang=js"
export * from "./TDMModalImport.vue?vue&type=script&lang=js"

import "./TDMModalImport.vue?vue&type=style&index=0&id=2a5223d7&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__